import { render, staticRenderFns } from "./InventoryStatus.vue?vue&type=template&id=7d6160fd&scoped=true"
import script from "./InventoryStatus.vue?vue&type=script&lang=js"
export * from "./InventoryStatus.vue?vue&type=script&lang=js"
import style0 from "./InventoryStatus.vue?vue&type=style&index=0&id=7d6160fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6160fd",
  null
  
)

export default component.exports